import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import env from '../config/env';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Search, Pencil, Trash2, Boxes, ArrowLeft, ArrowRight } from 'lucide-react';
import Select from 'react-select';

function Stoku() {
  const { roli, lokacion_id } = useAuth();
  const { theme } = useTheme();
  const [stok, setStok] = useState([]);
  const [produktet, setProduktet] = useState([]);
  const [madhesite, setMadhesite] = useState([]);
  const [ngjyrat, setNgjyrat] = useState([]);
  const [lokacionet, setLokacionet] = useState([]);

  const [form, setForm] = useState({
    produkt_id: '',
    madhesi_id: '',
    ngjyra_id: '',
    sasia: '',
    orig_madhesi_id: '',
    orig_ngjyra_id: '',
      lokacion_id: ''
  });
  const [editKey, setEditKey] = useState(null);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const [filterProdukt, setFilterProdukt] = useState('');
  const [filterMadhesi, setFilterMadhesi] = useState('');
  const [filterNgjyra, setFilterNgjyra] = useState('');
  const [filterLokacion, setFilterLokacion] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const perFaqe = 8;

  const loadData = async () => {
    try {
      const params = {};
      if (roli === 'admin' && filterLokacion) {
        params.lokacion_id = filterLokacion;
      }

      const [resStok, resProdukte, resMadhesi, resNgjyra] = await Promise.all([
        apiService.get('/kerkimi-stokut', { params: { q: '', ...params } }),
        apiService.get('/produkte'),
        apiService.get('/madhesite'),
        apiService.get('/ngjyrat')
      ]);

      if (roli === 'admin') {
        const resLokacione = await apiService.get('/lokacionet');
        setLokacionet(Array.isArray(resLokacione) ? resLokacione : (resLokacione?.data || []));
      }

      setStok(Array.isArray(resStok) ? resStok : (resStok?.data || []));
      setProduktet(Array.isArray(resProdukte) ? resProdukte : (resProdukte?.data || []));
      setMadhesite(Array.isArray(resMadhesi) ? resMadhesi : (resMadhesi?.data || []));
      setNgjyrat(Array.isArray(resNgjyra) ? resNgjyra : (resNgjyra?.data || []));
    } catch (error) {
      logger.error('Gabim gjatë ngarkimit:', error);
      setMessage('Gabim gjatë ngarkimit.');
      setIsError(true);
    }
  };

useEffect(() => {
  loadData();
}, [filterLokacion]);

  useEffect(() => { setCurrentPage(1); }, [filterProdukt, filterMadhesi, filterNgjyra]);
  useEffect(() => {
  if (roli !== 'admin' && lokacion_id) {
    setForm((f) => ({ ...f, lokacion_id }));
  }
}, [roli, lokacion_id]);

useEffect(() => {
  if (roli !== 'admin') {
    setFilterLokacion('');
  }
}, [roli]);



  const { mutate: updateStok, loading: savingStok } = useMutation(
    async (data) => {
      return await apiService.post(`/produkte/${data.produkt_id}/stok`, {
        madhesi_id: data.madhesi_id || null,
        ngjyra_id: data.ngjyra_id || null,
        sasia: parseInt(data.sasia),
        orig_madhesi_id: data.orig_madhesi_id || null,
        orig_ngjyra_id: data.orig_ngjyra_id || null,
        lokacion_id: data.lokacion_id
      });
    },
    {
      successMessage: 'Stoku u ruajt me sukses!',
      onSuccess: () => {
        setForm({
          produkt_id: '', madhesi_id: '', ngjyra_id: '', sasia: '',
          orig_madhesi_id: '', orig_ngjyra_id: '', lokacion_id: roli === 'admin' ? form.lokacion_id : lokacion_id
        });
        setEditKey(null);
        loadData();
      }
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    updateStok({
      produkt_id: form.produkt_id,
      madhesi_id: form.madhesi_id,
      ngjyra_id: form.ngjyra_id,
      sasia: form.sasia,
      orig_madhesi_id: form.orig_madhesi_id,
      orig_ngjyra_id: form.orig_ngjyra_id,
      lokacion_id: roli === 'admin' ? form.lokacion_id : lokacion_id
    });
  };

  const handleEdit = (produktId, s) => {
    const lokacionIdEdit = roli === 'admin' ? filterLokacion : s.lokacion_id;

    setForm({
      produkt_id: produktId,
      madhesi_id: s.madhesi_id,
      ngjyra_id: s.ngjyra_id,
      sasia: s.sasia,
      orig_madhesi_id: s.madhesi_id,
      orig_ngjyra_id: s.ngjyra_id,
      lokacion_id: lokacionIdEdit || ''
    });
    setEditKey(`${produktId}-${s.madhesi_id}-${s.ngjyra_id}`);
  };

  const { mutate: deleteStok } = useMutation(
    async ({ produktId, madhesiId, ngjyraId, lokacionId }) => {
      return await apiService.delete(`/produkte/${produktId}/stok`, {
        data: {
          madhesi_id: madhesiId,
          ngjyra_id: ngjyraId,
          lokacion_id: lokacionId
        }
      });
    },
    {
      successMessage: 'Stoku u fshi me sukses!',
      onSuccess: () => {
        loadData();
      }
    }
  );

  const handleDelete = async (produktId, madhesiId, ngjyraId, rowLokacionId) => {
    if (!window.confirm("A jeni i sigurt që doni ta fshini këtë stok?")) return;
    deleteStok({
      produktId,
      madhesiId,
      ngjyraId,
      lokacionId: roli === 'admin'
        ? (filterLokacion || form.lokacion_id || rowLokacionId)
        : lokacion_id
    });
  };
// const allStok = stok
//   .filter(p => p.eshte_aktiv !== 2) // ✅ filtro produktet e fshira
//   .flatMap(p =>
//     p.stok.map(s => ({
//       produkt_id: p.id,
//       emri: p.emri,
//       madhesi: s.madhesi,
//       ngjyra: s.ngjyra,
//       madhesi_id: s.madhesi_id,
//       ngjyra_id: s.ngjyra_id,
//       sasia: s.sasia
//     }))
//   );

const allStok = stok
.filter(p => p.eshte_aktiv !== 2) // ✅ filtro produktet e fshira
.flatMap(p =>
  p.stok.map(s => ({
    produkt_id: p.id,
    emri: p.emri,
    madhesi: s.madhesi,
    ngjyra: s.ngjyra,
    madhesi_id: s.madhesi_id,
    ngjyra_id: s.ngjyra_id,
    sasia: s.sasia,
    lokacion_id: s.lokacion_id,
    lokacion_emri: s.lokacion_emri // nëse e përfshin nga backend
  }))
)


// const filteredStok = allStok.filter(s => {
//   const produktMatch = !filterProdukt || s.emri.toLowerCase().includes(filterProdukt.toLowerCase());
//   const madhesiMatch = !filterMadhesi || s.madhesi_id == filterMadhesi;
//   const ngjyraMatch = !filterNgjyra || s.ngjyra_id == filterNgjyra;
//   return produktMatch && madhesiMatch && ngjyraMatch;
// });

const filteredStok = allStok.filter(s => {
  const produktMatch = !filterProdukt || s.emri.toLowerCase().includes(filterProdukt.toLowerCase());
  const madhesiMatch = !filterMadhesi || s.madhesi_id == filterMadhesi;
  const ngjyraMatch = !filterNgjyra || s.ngjyra_id == filterNgjyra;
  const lokacionMatch = !filterLokacion || s.lokacion_id == filterLokacion;
  return produktMatch && madhesiMatch && ngjyraMatch && lokacionMatch;
});



  const totalPages = Math.ceil(filteredStok.length / perFaqe);
  const visibleStok = filteredStok.slice((currentPage - 1) * perFaqe, currentPage * perFaqe);

  // Custom styles for react-select based on theme
  const selectStyles = theme === 'dark' ? {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: state.isFocused ? '#f59e0b' : '#475569',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: '#475569',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#78350f' : state.isSelected ? '#f59e0b' : '#1e293b',
      color: state.isSelected ? 'white' : '#e2e8f0',
    }),
    singleValue: (base) => ({ ...base, color: '#e2e8f0' }),
    input: (base) => ({ ...base, color: '#e2e8f0' }),
    placeholder: (base) => ({ ...base, color: '#94a3b8' }),
  } : {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'transparent',
      borderColor: state.isFocused ? '#f59e0b' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'white',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#fef3c7' : state.isSelected ? '#fbbf24' : 'white',
      color: state.isSelected ? 'white' : '#111827',
    }),
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <Boxes size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Menaxhimi i Stokut
      </h2>

      {message && (
        <div className={`mb-6 p-4 rounded-xl flex items-center gap-3 font-semibold animate-slide-down ${
          isError 
            ? 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800' 
            : 'bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800'
        }`}>
          <p>{message}</p>
        </div>
      )}

      {/* Forma për shtim/edit */}
      <form onSubmit={handleSubmit} className="card-premium p-6 mb-6 grid grid-cols-1 md:grid-cols-5 gap-4">
       {/* <Select
  options={produktet
    .filter(p => p.eshte_aktiv != 2)
    .map(p => ({
    value: p.id,
    label: p.emri,
    image: p.foto?.[0]?.file_path ? `${env.API_URL_Image}/storage/${p.foto[0].file_path}` : null
  }))}
  value={
    form.produkt_id
      ? {
          value: form.produkt_id,
          label: produktet.find(p => p.id === form.produkt_id)?.emri,
          image: produktet.find(p => p.id === form.produkt_id)?.foto?.[0]?.file_path
            ? `${env.API_URL_Image}/storage/${produktet.find(p => p.id === form.produkt_id)?.foto[0]?.file_path}`
            : null
        }
      : null
  }
  onChange={(option) =>
    setForm({ ...form, produkt_id: option?.value || '' })
  }
  placeholder="Zgjidh produktin"
  className="w-full"
  isClearable
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      {option.image && (
        <img src={option.image} alt={option.label} className="w-6 h-6 rounded object-cover" />
      )}
      <span>{option.label}</span>
    </div>
  )}
/> */}

<Select
  options={produktet
    .filter(p => p.eshte_aktiv != 2)
    .map(p => ({
      value: p.id,
      label: `${p.kodi || ''} - ${p.emri}`,
      image: p.foto?.[0]?.file_path ? `${env.API_URL_Image}/storage/${p.foto[0].file_path}` : null
    }))}
  value={
    form.produkt_id
      ? {
          value: form.produkt_id,
          label: `${produktet.find(p => p.id === parseInt(form.produkt_id))?.kodi || ''} - ${produktet.find(p => p.id === parseInt(form.produkt_id))?.emri}`,
          image: produktet.find(p => p.id === parseInt(form.produkt_id))?.foto?.[0]?.file_path
            ? `${env.API_URL_Image}/storage/${produktet.find(p => p.id === parseInt(form.produkt_id)).foto[0].file_path}`
            : null
        }
      : null
  }
   onChange={(option) =>
    setForm({ ...form, produkt_id: option?.value || '' })
  }
  placeholder="Zgjidh produktin"
  className="w-full"
  isClearable
  styles={selectStyles}
  classNamePrefix="react-select"
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      {option.image && (
        <img src={option.image} alt={option.label} className="w-8 h-8 object-cover rounded" />
      )}
      <span>{option.label}</span>
    </div>
  )}
  filterOption={(option, inputValue) =>
    option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
/>

        {/* <select value={form.produkt_id} onChange={e => setForm({ ...form, produkt_id: e.target.value })} required
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500">
          <option value="">Zgjidh produktin</option>
          {produktet.map(p => <option key={p.id} value={p.id}>{p.emri}</option>)}
        </select> */}
        <select value={form.madhesi_id ?? ''} onChange={e => setForm({ ...form, madhesi_id: e.target.value || '' })}
          className="input-premium"
          title="Opsionale – lëreni bosh për produkte pa madhësi">
          <option value="">Madhësia (opsionale)</option>
          {madhesite.map(m => <option key={m.id} value={m.id}>{m.emri}</option>)}
        </select>
        <select value={form.ngjyra_id ?? ''} onChange={e => setForm({ ...form, ngjyra_id: e.target.value || '' })}
          className="input-premium"
          title="Opsionale – lëreni bosh për produkte pa ngjyrë">
          <option value="">Ngjyra (opsionale)</option>
          {ngjyrat.map(n => <option key={n.id} value={n.id}>{n.emri}</option>)}
        </select>
        <input type="number" min="0" placeholder="Sasia" value={form.sasia}
          onChange={e => setForm({ ...form, sasia: e.target.value })}
          className="input-premium" />
       {roli === 'admin' && (
  <select
    value={form.lokacion_id}
    onChange={e => setForm({ ...form, lokacion_id: e.target.value })}
    className="input-premium"
  >
    <option value="">Zgjidh lokacionin</option>
    {lokacionet.map(l => (
      <option key={l.id} value={l.id}>{l.emri}</option>
    ))}
  </select>
)}
        <button type="submit"
          className="btn-primary"
          disabled={savingStok}
        >
          {savingStok ? 'Duke ruajtur...' : (editKey ? "Përditëso" : "Shto")}
        </button>
      </form>

      {/* Filtrat */}
      <div className="card-premium p-4 mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
         <div className="relative w-full">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-dark-400" size={18} />
            <input
              type="text"
              placeholder="Kërko..."
              value={filterProdukt}
              onChange={(e) => setFilterProdukt(e.target.value.toLowerCase())}
              className="input-premium pl-12"
            />
          </div>
        <select value={filterMadhesi} onChange={e => setFilterMadhesi(e.target.value)}
          className="input-premium">
          <option value="">Të gjitha madhësitë</option>
          {madhesite.map(m => <option key={m.id} value={m.id}>{m.emri}</option>)}
        </select>
        <select value={filterNgjyra} onChange={e => setFilterNgjyra(e.target.value)}
          className="input-premium">
          <option value="">Të gjitha ngjyrat</option>
          {ngjyrat.map(n => <option key={n.id} value={n.id}>{n.emri}</option>)}
        </select>
        {roli === 'admin' && (
  <select
    value={filterLokacion}
    onChange={e => setFilterLokacion(e.target.value)}
    className="input-premium"
  >
    <option value="">Të gjithë lokacionet</option>
    {lokacionet.map(l => (
      <option key={l.id} value={l.id}>{l.emri}</option>
    ))}
  </select>
)}
      </div>

      {/* Paginimi elegant */}
    {totalPages > 1 && (
  <div className="card-premium flex items-center justify-center gap-6 mt-6 flex-wrap px-6 py-4 mb-6">
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className={`btn-premium-secondary flex items-center gap-2 text-sm ${
        currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      <ArrowLeft size={16} /> Mbrapa
    </button>

    <span className="text-gray-700 dark:text-gray-300 text-sm font-medium">
      Faqja <span className="text-primary-600 dark:text-primary-400 font-semibold">{currentPage}</span> nga{' '}
      <span className="font-semibold">{totalPages}</span>
    </span>

    <button
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className={`btn-premium-secondary flex items-center gap-2 text-sm ${
        currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      Para <ArrowRight size={16} />
    </button>
  </div>
)}

      {/* Tabela */}
      <div className="card-premium overflow-x-auto hidden md:block">
        <table className="table-premium">
          <thead>
            <tr>
              <th>Produkti</th>
              <th>Madhësia</th>
              <th>Ngjyra</th>
              <th>Sasia</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
  {visibleStok.map((s) => (
    <tr key={`${s.produkt_id}-${s.madhesi_id}-${s.ngjyra_id}`}>
      <td className="font-medium">{s.emri}</td>
      <td>{s.madhesi?.emri || '-'}</td>
      <td>{s.ngjyra?.emri || '-'}</td>
      <td>
        <span className={`badge-premium ${
          s.sasia > 0 ? 'badge-success' : 'badge-danger'
        }`}>
          {s.sasia} copë
        </span>
      </td>
      <td>
        <div className="flex gap-2">
          {!(roli === 'admin' && !filterLokacion) && (
            <button onClick={() => handleEdit(s.produkt_id, s)} className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 flex items-center gap-1 transition-colors">
              <Pencil size={16} /> Edito
            </button>
          )}
          <button onClick={() => handleDelete(s.produkt_id, s.madhesi_id, s.ngjyra_id, s.lokacion_id)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 flex items-center gap-1 transition-colors">
            <Trash2 size={16} /> Fshi
          </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>
        </table>
      </div>
      {/* View për mobile – karta për çdo stok */}
<div className="md:hidden space-y-4">
  {visibleStok.map((s) => (
    <div key={`${s.produkt_id}-${s.madhesi_id}-${s.ngjyra_id}`} className="card-premium p-4">
      <p className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1"><strong>Produkti:</strong> {s.emri}</p>
      <p className="text-sm text-gray-600 dark:text-gray-400"><strong>Madhësia:</strong> {s.madhesi?.emri || '-'}</p>
      <p className="text-sm text-gray-600 dark:text-gray-400"><strong>Ngjyra:</strong> {s.ngjyra?.emri || '-'}</p>
      <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
        <strong>Sasia:</strong>{' '}
        <span className={`badge-premium ${
          s.sasia > 0 ? 'badge-success' : 'badge-danger'
        }`}>
          {s.sasia} copë
        </span>
      </p>
      <div className="flex gap-4 mt-3">
        {!(roli === 'admin' && !filterLokacion) && (
          <button
            onClick={() => handleEdit(s.produkt_id, s)}
            className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 flex items-center gap-1 text-sm transition-colors"
          >
            <Pencil size={16} /> Edito
          </button>
        )}
        <button
          onClick={() => handleDelete(s.produkt_id, s.madhesi_id, s.ngjyra_id, s.lokacion_id)}
          className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 flex items-center gap-1 text-sm transition-colors"
        >
          <Trash2 size={16} /> Fshi
        </button>
      </div>
    </div>
  ))}
</div>

    </div>

    
  );
}

export default Stoku;
